import React from 'react';
import { StripeConnectAccount } from '../../../../components/StripeConnectAccount';
export const RegistrationPayout = (props) => {
    const { event, disabled } = props;
    return React.createElement(StripeConnectAccount, { competition: event, disabled: disabled });
};
